import App from './views/App.vue';
import router from './routes';

import AkApprovalStatusSelect from "./widgets/AkApprovalStatusSelect.vue";
import AkTextSmall from "./widgets/AkTextSmall.vue";
import CmsFormDashboard from "./components/CmsFormDashboard";
import AkReadOnlyLink from "./widgets/AkReadOnlyLink.vue";

Vue.component('ak-approval-status-select', AkApprovalStatusSelect);
Vue.component('ak-text-small', AkTextSmall);
Vue.component('ak-read-only-link', AkReadOnlyLink);
Vue.component('cms-form-dashboard', CmsFormDashboard);

let app = new Vue({
        data() { 
            return {
                globalMessages: []
            }
        },
        router,
        render: h => h(App),
}).$mount('#app')

AppKit.init(app);
